import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import EventDateFilter from '../Filters/EventDateFilter';
import EventTourFilter from '../Filters/EventTourFilter';
import EventTypeFilter from '../Filters/EventTypeFilter';
import EventUtrTypeFilter from '../Filters/EventUtrTypeFilter';
import EventPrizeMoneyFilter from '../Filters/EventPrizeMoneyFilter';
import EventsMoreDesktopFilter from '../Filters/EventsMoreDesktopFilter';
import EventsMoreMobileFilter from '../Filters/EventsMoreMobileFilter';
import BallTypeFilter from '../Filters/BallTypeFilter';
import { fetchEventTours } from '../../../actions/event-template-actions';

const EventFilters = (props) => {
    const {
        search,
        handleFilterClick,
        state,
        userLoggedIn,
        // showPowerPopup,
        hideFilters,
        // isPowerUser,
        _this,
        searchTypes,
        filterInputs,
        auth,
        filterType,
    } = props;

    const { filters = {} } = search;
    const showTennisContent = auth?.feedPreferences?.showTennisContent;
    const showPickleballContent = !!auth?.feedPreferences?.showPickleballContent;
    const isUserLoggedInAndToursAvailable = state.availableToursList && state.availableToursList.length > 0 && userLoggedIn;
    const showTennisFilters = !!filterInputs?.sportTypes?.tennis;
    const showPickleballFilters = !!filterInputs?.sportTypes?.pickleball;

    const eventsMoreMobileFiltersAreActive = ((search.filters && (
        (filters.eventTypes && Object.values(filters.eventTypes).indexOf(true) > -1) ||
        (filters.eventUtrTypes && Object.values(filters.eventUtrTypes).indexOf(true) > -1) ||
        (filters.prizeMoneyMin && filters.prizeMoneyMin > 1) ||
        (filters.prizeMoneyMax && filters.prizeMoneyMax < searchTypes.prizeMoneyValues.length) ||
        (filters.eventTeamTypes && Object.values(filters.eventTeamTypes).indexOf(true) > -1) ||
        (filters.genders && Object.values(filters.genders).indexOf(true) > -1) ||
        filters.gender || filters.utrMin > 1 || filters.utrMax < 16)) ||
        (filters.ballTypes && Object.values(filters.ballTypes).indexOf(true) > -1)
    );

    const eventsMoreDesktopFiltersAreActive = (search.filters && (
        filters.utrMin > 1 || (filters.utrMax < 16 && showTennisFilters && !showPickleballFilters) || (filters.utrMax < 10 && showPickleballFilters && !showTennisFilters) ||
        (filters.eventTeamTypes && Object.values(filters.eventTeamTypes).indexOf(true) > -1) ||
        (filters.genders && Object.values(filters.genders).indexOf(true) > -1)
    ));

    const commonFilterProps = {
        filters,
        filterInputs,
        handleFilterClick,
        filterModal: state.filterModal,
        closeModals: _this.closeModals,
        handleFilterSubmit: _this.handleFilterSubmit,
        clearFilters: _this.clearFilters,
        handleFilterUpdate: _this.handleFilterUpdate,
        auth,
        search,
    };

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchEventTours());
        if (showPickleballFilters && !showTennisFilters) {
            _this.handleFilterSubmit({
                sportTypes: {
                    tennis: false,
                    pickleball: true,
                },
            });
        } else {
            _this.handleFilterSubmit({
                sportTypes: {
                    tennis: auth?.user ? showTennisContent : true,
                    pickleball: auth?.user ? showPickleballContent : true,
                },
            });
        }
    }, [filterType, search?.filters?.sportTypes?.tennis, search?.filters?.sportTypes?.pickleball]);
    return (
        <React.Fragment>
            <EventDateFilter
                {...commonFilterProps}
                data-testid="search.events.filter.date"
            />
            {isUserLoggedInAndToursAvailable && !hideFilters.tours && (
                <EventTourFilter
                    {...commonFilterProps}
                    searchTypes={_this.state}
                    desktopOnly={true}
                    data-testid="search.events.filter.tours"
                />
            )}
            {(userLoggedIn) && (
                <React.Fragment>
                    <EventTypeFilter
                        {...commonFilterProps}
                        searchTypes={searchTypes}
                        desktopOnly={true}
                        data-testid="search.events.filter.event-type"
                    />
                    {showTennisFilters && (
                        <BallTypeFilter
                            {...commonFilterProps}
                            searchTypes={searchTypes}
                            desktopOnly={true}
                            data-testid="search.events.filter.ball-type"
                        />
                    )}
                    {showTennisFilters && (
                        <EventUtrTypeFilter
                            {...commonFilterProps}
                            searchTypes={searchTypes}
                            desktopOnly={true}
                            data-testid="search.events.filter.utr-type"
                        />
                    )}
                    <EventPrizeMoneyFilter
                        {...commonFilterProps}
                        searchTypes={searchTypes}
                        desktopOnly={true}
                        data-testid="search.events.filter.prize-money"
                    />
                    <EventsMoreDesktopFilter
                        {...commonFilterProps}
                        searchTypes={searchTypes}
                        eventsMoreDesktopFiltersAreActive={eventsMoreDesktopFiltersAreActive}
                        desktopOnly={true}
                        data-testid="search.events.filter.more-desktop"
                    />
                </React.Fragment>
            )}
            {userLoggedIn && (
                <EventsMoreMobileFilter
                    {...commonFilterProps}
                    searchTypes={searchTypes}
                    eventsMoreMobileFiltersAreActive={eventsMoreMobileFiltersAreActive}
                    userLoggedIn={userLoggedIn}
                    hideFilters={hideFilters}
                    state={state}
                    mobileOnly={true}
                    data-testid="search.events.filter.more-mobile"
                />
            )}
        </React.Fragment>
    );
};

EventFilters.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
    state: PropTypes.instanceOf(Object).isRequired,
    hideFilters: PropTypes.instanceOf(Object).isRequired,
    filterType: PropTypes.string.isRequired,

};

export default EventFilters;
